// Lightweight analytics helper — fires & forgets POSTs to /api/analytics/track
const API_URL = process.env.REACT_APP_BACKEND_URL;

const ALLOWED = new Set([
  'page_visit',
  'menu_click',
  'online_order_click',
  'category_click',
  'reservation_click',
  'campaign_view',
  'campaign_click',
]);

const getSessionId = () => {
  try {
    let sid = sessionStorage.getItem('gomsu-session-id');
    if (!sid) {
      sid = (window.crypto?.randomUUID && window.crypto.randomUUID()) || `s-${Date.now()}-${Math.random().toString(36).slice(2)}`;
      sessionStorage.setItem('gomsu-session-id', sid);
    }
    return sid;
  } catch {
    return null;
  }
};

export const trackEvent = (eventType, metadata = null) => {
  if (!ALLOWED.has(eventType)) return;
  const payload = JSON.stringify({
    event_type: eventType,
    metadata: metadata || {},
    session_id: getSessionId(),
  });
  try {
    const url = `${API_URL}/api/analytics/track`;
    // Use sendBeacon when available so it survives page unload (e.g., online order navigation)
    if (navigator.sendBeacon) {
      const blob = new Blob([payload], { type: 'application/json' });
      const ok = navigator.sendBeacon(url, blob);
      if (ok) return;
    }
    fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: payload,
      keepalive: true,
    }).catch(() => {});
  } catch {
    // Silent fail — analytics must never break the app
  }
};

// Helper that only fires once per session for the given key
export const trackOnce = (eventType, metadata = null) => {
  try {
    const key = `gomsu-tracked-${eventType}-${JSON.stringify(metadata || {})}`;
    if (sessionStorage.getItem(key)) return;
    sessionStorage.setItem(key, '1');
  } catch {
    // ignore
  }
  trackEvent(eventType, metadata);
};
